<!--消缺管理界面-->
<template>
  <treeBody>
    <!--左边-->
    <entityTypeTree
      :autoSelectMethod="autoSelectMethod"
      slot="tree"
      @checkItem="checkItem"
      :dataList="archivesTypeList"
    ></entityTypeTree>
    <!--右边-->
    <div class="rightBody" slot="body">
      <div class="defectContainer">
        <div class="searchContainer">
          <el-form ref="form" :model="form" label-width="80px" size="medium" style="display: flex;width: auto;">
            <!-- <el-form-item label="设备">
							<el-cascader v-model="form.typeCode" filterable :options="archivesTypeList" :props="props"></el-cascader>
						</el-form-item> -->
            <el-form-item label="缺陷等级">
              <el-select v-model="form.priority" clearable placeholder="请选择" @change="getNowPageDataList">
                <el-option v-for="item in priorityList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消缺名称">
              <el-input v-model="form.name" placeholder="请输入消缺名称" @change="getNowPageDataList"></el-input>
            </el-form-item>
          </el-form>
          <el-row>
            <el-button type="primary" size="mini" @click="search">查 询</el-button>
            <el-button type="primary" size="mini" @click="create">新建消缺</el-button>
          </el-row>
        </div>
        <div class="defectMessageList custom-scrollbar">
          <div class="defectMessageBox" v-for="item in nowPageDataList">
            <el-row>
              <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="editDefect(item)"></el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteDefect(item)"></el-button>
            </el-row>
            <p class="defectTitle">{{ item.name }}</p>
            <p><span class="defectLabel">缺陷等级：</span>{{ priorityMatch[item.priority] }}</p>
            <p><span class="defectLabel">缺陷危害：</span>{{ item.harm }}</p>
            <p><span class="defectLabel">处理建议：</span>{{ item.proposal }}</p>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <UpdateDefectDialog ref="UpdateDefectDialog"></UpdateDefectDialog>
      </div>
    </div>
  </treeBody>
</template>

<script>
import treeBody from '@/components/module/slotModule/treeBody.vue';
import entityTypeTree from '@/components/module/tree/entityTypeTree.vue';
import UpdateDefectDialog from './UpdateDefectDialog.vue';

export default {
  components: {
    treeBody,
    entityTypeTree,
    UpdateDefectDialog
  },
  props: {},
  data() {
    return {
      total: 0,
      currentPage: 1,
      currentSize: 10,
      nowEntity: {},
      history: {},
      form: {
        typeCode: '',
        name: '',
        priority: ''
      },
      dataList: [],
      nowPageDataList: [],
      props: {
        children: 'next',
        label: 'typeName',
        value: 'typeCode',
        expandTrigger: 'hover',
        checkStrictly: true
        //entityName:'entityName'
      }
    };
  },
  created() {},
  mounted() {},
  destroyed() {},
  computed: {
    archivesTypeList() {
      return this.$store.archivesStore.getters.getArchivesTypeList;
    },
    priorityList() {
      return this.$store.orderGroupStore.state.priorityList;
    },
    priorityMatch() {
      return this.$store.orderGroupStore.state.priorityMatch;
    }
  },
  watch: {},
  methods: {
    autoSelectMethod(item) {
      if (!isempty(this.history)) {
        return this.history.id == item.id;
      } else {
        return item.entityName == 'MisEntityType';
      }
    },
    // 选中设备树
    checkItem(item) {
      this.nowEntity = item;
      this.form.typeCode = item.typeCode;
      this.form.typeName = item.typeName;
      this.history = {};
      this.form = {
        name: '',
        priority: ''
      };
      this.search();
    },
    // 查询
    search() {
      this.$api.workDefectApi.findDefectListByTypeCode(
        this.nowEntity.typeCode,
        respon => {
          //this.$api.workDefectApi.findDefectListByTypeCode(typeCode, respon => {
          //没有返回typeName
          this.dataList = copy(respon);
          this.getNowPageDataList();
        },
        err => {
          this.$message(err);
        }
      );
    },
    getNowPageDataList() {
      // 过滤缺陷等级
      var list1, list2;
      if (this.form.priority != '') {
        list1 = this.dataList.filter(item => {
          return item.priority == this.form.priority;
        });
      } else {
        list1 = this.dataList;
      }
      
      // 过滤名称关键字
      list2 = list1.filter(item => {
        if(isempty(item.name)){
          return []
        }
        return item.name.indexOf(this.form.name) > -1;
      });
      // 当前页显示
      this.total = list2.length;
      var result = list2.filter((item, index) => {
        return index < this.currentPage * this.currentSize && index >= (this.currentPage - 1) * this.currentSize;
      });
      this.nowPageDataList = result;
    },
    // 新建消缺
    create() {
      this.$refs.UpdateDefectDialog.open('新建消缺', {}, result => {
        this.$api.workDefectApi.saveDefect(
          undefined,
          result.name,
          result.defectType,
          result.valueType,
          result.harm,
          result.proposal,
          result.priority,
          result.typeCode,
          respon => {
            //this.$api.workDefectApi.saveDefect(undefined, result.name, result.defectType, result.valueType, result.harm, result.proposal, result.priority, this.nowEntity.typeCode, respon => {
            this.$message({
              message: '新建消缺成功！',
              type: 'success'
            });
            this.search();
          },
          err => {
            this.$message({
              message: err,
              type: 'error'
            });
          }
        );
      });
    },
    // 编辑消缺
    editDefect(defectData) {
      this.$refs.UpdateDefectDialog.open('编辑消缺', defectData, result => {
        this.$api.workDefectApi.saveDefect(
          defectData.pkid,
          result.name,
          result.defectType,
          result.valueType,
          result.harm,
          result.proposal,
          result.priority,
          result.typeCode,
          respon => {
            this.$message({
              message: '编辑消缺成功！',
              type: 'success'
            });
            this.search();
          },
          err => {
            this.$message({
              message: err,
              type: 'error'
            });
          }
        );
      });
    },
    // 删除消缺
    deleteDefect(defectData) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.workDefectApi.deleteDefect(
            defectData.pkid,
            respon => {
              this.$message({
                message: '删除成功！',
                type: 'success'
              });
              this.search();
            },
            err => {
              this.$message({
                message: err,
                type: 'error'
              });
            }
          );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleSizeChange(val) {
      this.currentSize = val;
      this.getNowPageDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNowPageDataList();
    }
  }
};
</script>

<style scoped>
.defectContainer {
  height: 100%;
  background-color: #ffffff;
}

.searchContainer {
  display: flex;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: solid 1px #e4e4e4;
}

.searchContainer >>> .el-form-item {
  margin-bottom: 0;
}

.defectMessageList {
  height: calc(100% - 180px);
  padding: 12px 20px;
  box-sizing: border-box;
}

.defectMessageBox {
  border: solid 1px #e4e4e4;
  border-radius: 2px;
  padding: 10px 15px;
  margin-bottom: 10px;
  position: relative;
}

.defectMessageBox >>> .el-row {
  position: absolute;
  top: 10px;
  right: 10px;
}

.defectMessageBox:hover {
  border-color: #0099ff;
}

.defectMessageBox > p {
  line-height: 28px;
}

.defectTitle {
  font-weight: bold;
}

.defectLabel {
  color: #cccccc;
  margin-left: 30px;
}

.defectLabel:first-child {
  margin: 0;
}

>>> .el-pagination {
  margin: 10px 20px;
  float: right;
}
</style>
